/* eslint-disable prettier/prettier */
/*
public function showSignatures()
    {
        if ($this->pagePosition->y < $this->mm2p(40)) {
            $this->nextPage();
        }
        $this->placeFilesystemImage($this->pagePosition->x - $this->mm2p(10), $this->pagePosition->y - $this->mm2p(15), $this->mm2p(60), $this->pagePosition->y, app_path() . '/Libraries/Pdf/images/signature_knackstedt.png');
        $this->placeFilesystemImage($this->mm2p(92), $this->pagePosition->y - $this->mm2p(15), $this->mm2p(118), $this->pagePosition->y, app_path() . '/Libraries/Pdf/images/signature_hajetschek.png', 'meet', 0.25);
        // $this->placeFilesystemImage($this->mm2p(90), $this->pagePosition->y - $this->mm2p(11), $this->mm2p(118), $this->pagePosition->y, app_path() . '/Libraries/Pdf/images/signature_tourneau.png', 'meet', 1.1);
        $this->pagePosition->y -= $this->mm2p(15);
        $name = "Marc Knackstedt\t\tNina Hajetschek";
        $this->textflow = $this->pdf->add_textflow($this->textflow, $name, $this->regularOptions . " fillcolor=" . $this->colors->rgb->copy);
        $name = "\n\nÖffentliche Sachversicherung Braunschweig";
        $this->textflow = $this->pdf->add_textflow($this->textflow, $name, $this->regularOptions . " fillcolor=" . $this->colors->rgb->copy);

        $this->dumpThisTextflow();
    }
*/
import { hajetschek } from "./images/signatureHajetschek";
import { imageKnackstedt } from "./images/signatureKnackstedt";


const signatures = {
    // Tabelle ohne Rahmen, 1. Zeile mit den Bildern, 2. Zeile mit den Namen
    style: "tableTextRegular",
    layout: "noBorders",
    margin: [0, 50, 0, 0],
    table: {
        widths: [100, 100],
        body: [
            [{ image: imageKnackstedt, fit: [100, 150], alignment: 'center' }, { image: hajetschek, fit: [100, 100], alignment: 'center' }],
            [{ text: "Marc Knackstedt", alignment: "center" }, { text: "Nina Hajetschek", alignment: 'center' }]
        ]
    }
}

export { signatures }